import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiCopilotService {
  private readonly _open$ = new Subject<void>();
  readonly open$ = this._open$.asObservable();

  triggerOpen(): void {
    this._open$.next();
  }
}
